import api from "./api.ts";
import { Campaign } from "../types/index.ts";

const url = process.env.REACT_APP_DB_URI;

// Unified error handler
const handleApiError = (err: any) => {
  const errorData = err.response?.data || {
    message: err.message || "API request failed",
    status: err.response?.status || 500
  };
  throw errorData;
};

// ================== Campaign Functions ==================
export const postCampaign = async (data: Partial<Campaign>) => {
  try {
    return await api.post(`${url}/campaigns/`, data);
  } catch (err) {
    handleApiError(err);
  }
};

//update Campaign
export const updateCampaign = async (id: string, data: Partial<Campaign>) => {
  try {
    return await api.put(`${url}/campaigns/${id}/`, data);
  } catch (err) {
    handleApiError(err);
  }
}

export const getAllCampaigns = async (accessToken?: string) => {
  try {
    return await api.get(`${url}/campaigns/`);
  } catch (err) {
    handleApiError(err);
  }
};

export const getActiveCampaigns = async (accessToken?: string) => {
  try {
    return await api.get(`${url}/campaign-request/`);
  } catch (err) {
    handleApiError(err);
  }
};

export const getUserCampaigns = async (accessToken: string | undefined, id: string) => {
  try {
    return await api.get(`${url}/campaigns/campaigns-by-user/?user_id=${id}`);
  } catch (err) {
    handleApiError(err);
  }
};

export const getSingleCampaign = async (accessToken: string | undefined, id: string) => {
  try {
    return await api.get(`${url}/campaigns/${id}`);
  } catch (err) {
    handleApiError(err);
  }
};

export const deleteCampaign = async (id: string) => {
  try {
    return await api.delete(`${url}/campaigns/${id}/`);
  } catch (err) {
    handleApiError(err);
  }
};

// ================== Rules Functions ==================
export const postSingleCampaignRules = async (formData: any) => {
  try {
    return await api.post(`${url}/rules/`, formData);
  } catch (err) {
    handleApiError(err);
  }
};

export const getSingleCampaignRules = async (id: any) => {
  try {
    return await api.get(`${url}/rules/get_rules_by_campaign/?campaign_id=${id}`);
  } catch (err) {
    handleApiError(err);
  }
};

// ================== Tasks Functions ==================
export const postSingleCampaignTask = async (formData: any) => {
  try {
    return await api.post(`${url}/tasks/`, formData);
  } catch (err) {
    handleApiError(err);
  }
};

export const getSingleCampaignTask = async (id: any) => {
  try {
    return await api.get(`${url}/tasks/get-tasks-by-campaign/${id}/`);
  } catch (err) {
    handleApiError(err);
  }
};

// ================== Request Functions ==================
export const getCampaignRequest = async (accessToken: any, id: any) => {
  try {
    return await api.get(`${url}/campaign-request/get_campaign_requests_by_campaign/?campaign_id=${id}`);
  } catch (err) {
    handleApiError(err);
  }
};


export const updateTask = async (id: string, formData: FormData) => {
  try {
    return await api.patch(`${url}/tasks/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  } catch (err) {
    handleApiError(err);
  }
};

export const updateRules = async (id: string, formData: FormData) => {
  try {
    return await api.patch(`${url}/rules/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  } catch (err) {
    handleApiError(err);
  }
};



export const createCampaignRequest = async (requestData: any) => {
  try {
    const formData = new FormData();
    formData.append("is_deleted", String(requestData.is_deleted || false));
    formData.append("status", requestData.status || 'PENDING');
    formData.append("campaign", requestData.campaign || '');
    formData.append("user", String(requestData.user || ''));
    formData.append("region", requestData.region || '');
    formData.append("platforms", requestData.platforms || '');

    return await api.post(`${url}/campaign-request/`, formData);
  } catch (err) {
    handleApiError(err);
  }
};

export const updateCampaignRequest = async (accessToken: any, formData: FormData, id: string) => {
  try {
    return await api.patch(`${url}/campaign-request/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  } catch (err) {
    handleApiError(err);
  }
};
